document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-3)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('.JS-detail-3-photo-slider');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail3 = new Swiper(swiperSelector, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            centeredSlides: true,
            slidesPerView: 4,
            spaceBetween: 20,
            initialSlide: 0,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2,
                    initialSlide: 1
                },
                2000: {
                    slidesPerView: 4,
                    initialSlide: 2
                }
            }
        });
    }());
});